import { state, createMachine, reduce, transition, invoke, guard } from 'robot3';
import { useMachine } from 'svelte-robot-factory';
import { get } from "svelte/store";
import { isWpSuccess, wpFetchRestApi } from "../util";
const emptyWeekdays = [];
const emptyMonth = {
    month: 0,
    month_name: "",
    year: 0,
    previous_month: 0,
    next_month: 0,
};
const emptyWeeks = [];
const emptyCalendar = {
    weekday_names: emptyWeekdays,
    month: emptyMonth,
    weeks: emptyWeeks,
};
const initialContext = {
    calendar: emptyCalendar,
    selectedDay: null,
    currentDay: 0,
    monthToLoad: 0,
    error: null,
};
const createContext = (initialContext) => initialContext;
const initialize = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { calendar: ev.data.calendar, currentDay: ev.data.currentDay }));
const loadPreviousMonth = (ctx, __) => (Object.assign(Object.assign({}, ctx), { monthToLoad: ctx.calendar.month.previous_month }));
const loadNextMonth = (ctx, __) => (Object.assign(Object.assign({}, ctx), { monthToLoad: ctx.calendar.month.next_month }));
const loadCurrentMonth = (ctx, __) => (Object.assign(Object.assign({}, ctx), { monthToLoad: ctx.calendar.month.month }));
const setSelectedDay = (ctx, ev) => {
    const c = (Object.assign(Object.assign({}, ctx), { selectedDay: ev.data.day }));
    console.dir({ c, ev });
    return c;
};
const clearSelectedDay = (ctx) => (Object.assign(Object.assign({}, ctx), { selectedDay: null }));
const storeCalendar = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { calendar: ev.data }));
const clearError = (ctx) => (Object.assign(Object.assign({}, ctx), { error: null }));
const storeError = (ctx, ev) => {
    console.log(ev.error);
    return Object.assign(Object.assign({}, ctx), { error: ev.error });
};
async function loadMonth(ctx) {
    const endpoint = 'customercalendar/' + ctx.monthToLoad + '/' + ctx.currentDay;
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (!isWpSuccess(result)) {
        throw new Error(result.message);
    }
    return result.data;
}
const checkAvailability = (__, ev) => ev.data.day.is_available;
const machine = createMachine({
    not_initialized: state(transition('initialize', 'show_calendar', reduce(initialize))),
    show_calendar: state(transition('previous_month', 'loading_month', reduce(loadPreviousMonth)), transition('next_month', 'loading_month', reduce(loadNextMonth)), transition('current_month', 'loading_month', reduce(loadCurrentMonth)), transition('select_day', 'show_selected_day', guard(checkAvailability), reduce(setSelectedDay))),
    loading_month: invoke(loadMonth, transition('done', 'show_calendar', reduce(storeCalendar), reduce(clearError)), transition('error', 'show_calendar', reduce(storeError))),
    show_selected_day: state(transition('close_day', 'show_calendar', reduce(clearSelectedDay)))
}, createContext);
export const service = useMachine(machine, initialContext);
export function getService() {
    return get(service);
}
export function isCalendarShown(state) {
    return ['show_calendar', 'loading_month'].includes(state);
}
export function isDayShown(state) {
    return ['show_selected_day'].includes(state);
}
export function selectDay(day) {
    const service = getService();
    service.send({ type: 'select_day', data: { day } });
}
